import EventCreatePage from './EventCreatePageContainer'

export default EventCreatePage
